import * as THREE from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import Loading from "../Loading.js";
import EventEmitter from "./EventEmitter.js";

export default class Resources extends EventEmitter {
  constructor(sources) {
    super();

    this.sources = sources;

    this.items = {};
    this.toLoad = this.sources.length;
    this.loaded = 0;
    this.hasExperienceStarted = false;
    this.startButton = document.getElementById("start_experience")
    this.progressBar = document.getElementById("progress")

    this.setLoaders();
    this.setLoadEvent();
  }

  setLoaders() {
    this.loaders = {};
    this.loaders.gltfLoader = new GLTFLoader();
    this.loaders.textureLoader = new THREE.TextureLoader();
    this.loaders.cubeTextureLoader = new THREE.CubeTextureLoader();
  }

  setLoadEvent() {
    this.startButton.addEventListener("click", () => {
        if (!this.hasExperienceStarted) {

          this.progressBar.style.display = "block"
          this.startLoading();
          this.hasExperienceStarted = true;
          this.startButton.style.display = "none"
        }
      });
  }

  startLoading() {
    this.loading = new Loading();
    this.loading.setResourceLength(this.sources.length);

    // Load each source
    for (const source of this.sources) {
      if (source.type === "gltfModel") {
        this.loaders.gltfLoader.load(source.path, (file) => {
          this.sourceLoaded(source, file);
        });
      } else if (source.type === "texture") {
        this.loaders.textureLoader.load(source.path, (file) => {
          this.sourceLoaded(source, file);
        });
      } else if (source.type === "cubeTexture") {
        this.loaders.cubeTextureLoader.load(source.path, (file) => {
          this.sourceLoaded(source, file);
        });
      }
    }
  }

  sourceLoaded(source, file) {
    this.items[source.name] = file;

    this.loaded++;
    this.loading.incrementProgress();

    if (this.loaded === this.toLoad) {
      this.trigger("ready");
      this.loading.setLoadComplete();
    }
  }
}
